import type { IMatch } from '@/interface/IMatch';
import type { IMarketGroup, IPriceOption } from '@/interface/IOdds';
import { MarketType, OddsOption } from '@/interface/enum';
import { getTranslated } from '@/libraries/helpers/translationHelper';
import { i18n } from '@/libraries/i18n';
import { isNewBetType } from '@/libraries/marketGroupHelper';
import { isExtensionTemplate } from '@/libraries/oddsApi/priceOptionHelper';
import { isCorrectScoreMarket, isFastMarket } from '@/libraries/oddsDisplay';

export default {
    getNewBetTypeOption(option: IPriceOption, marketType: number) {
        if (marketType === MarketType.OddEven || marketType === MarketType.FH_OddEven) {
            return option.oddsOption === OddsOption.Odd ? i18n.t('odds_option_odd') : i18n.t('odds_option_even');
        }
        return option.optionName;
    },
    getOptionName(option: string, matchInfo: IMatch, marketType: number) {
        const extraInfo = option.split(';');
        if (extraInfo.length === 1) {
            return i18n.t(option).toString();
        }

        if (isCorrectScoreMarket(marketType)) {
            return i18n.t(extraInfo[0], {
                home: extraInfo[1],
                away: extraInfo[2],
            }).toString();
        }
        const homeTeam = getTranslated(matchInfo.homeTeam?.teamName);
        const awayTeam = getTranslated(matchInfo.awayTeam?.teamName);
        const a1x2Info = {
            team: extraInfo[1] === 'home' ? homeTeam : awayTeam,
            goals: extraInfo[2],
        };
        return i18n.t(extraInfo[0], a1x2Info).toString();
    },
    betOptionUseTemplate(marketType: number, marketGroup: IMarketGroup) {
        const useTemplateMarketTypes = [
            MarketType.Handicap,
            MarketType.FH_Handicap,
            MarketType.OverUnder,
            MarketType.FH_OverUnder,
            MarketType._1X2,
            MarketType.FH_1X2,
            MarketType.MoneyLine,
        ];
        return isNewBetType(marketGroup.id) && !isFastMarket(marketGroup.id) && useTemplateMarketTypes.includes(marketType) && isExtensionTemplate(marketGroup.homeTemplate);
    },
    getEuroHtFtOption(optionName: string) {
        /* eslint-disable camelcase */
        const htFt: Record<string, string> = {
            odds_option_htft_hh: '11',
            odds_option_htft_ha: '12',
            odds_option_htft_hd: '1X',
            odds_option_htft_ah: '21',
            odds_option_htft_aa: '22',
            odds_option_htft_ad: '2X',
            odds_option_htft_da: 'X2',
            odds_option_htft_dh: 'X1',
            odds_option_htft_dd: 'XX',
        };
        /* eslint-enable camelcase */

        return htFt[optionName];
    },
};
